import { useField } from 'formik';
import * as React from 'react';

import { FormHelperText, InputAdornment, StandardTextFieldProps, TextField } from '@mui/material';

import { InputBox } from './input.styles';

interface CustomInputProps extends StandardTextFieldProps {
  name: string;
  isMultiline?: boolean;
  mRow?: number;
  isLabelAtTop?: boolean;
  icon?: any
}

export const PyInput: React.FC<CustomInputProps> = ({
  fullWidth,
  variant = "outlined",
  name,
  isMultiline,
  mRow,
  isLabelAtTop = true,
  icon,
  ...props
}) => {
  const [field, meta] = useField(name);

  return (
    <InputBox fullWidth={fullWidth}>
      <TextField
      // style={{paddingLeft:"16pz"}}
        multiline={isMultiline}
        rows={isMultiline ? (mRow ? mRow : 3) : 0}
        className="input"
        {...field}
        {...props}
        InputLabelProps={{
          shrink: isLabelAtTop,
        }}
        InputProps={{
          startAdornment: (
            <>
              {icon && <InputAdornment position="start">{icon}</InputAdornment>}
            </>
          ),
        }}
      />

      {meta.touched && meta.error && (
        <FormHelperText className={"feedback"}>{meta.error}</FormHelperText>
      )}
    </InputBox>
  );
};
